import React from "react"

import * as bulletinBoardCardStyles from "../styles/BulletinBoardCard.module.css"

import WPCta from "./_base/WPCta"

export default function BulletinBoardCard(props) {
  const { content } = props


  return (
    <>
      <div className={`row justify-content-center ${bulletinBoardCardStyles.wrapper}`}>
        <div className={`col-12 ${bulletinBoardCardStyles.ctaWrapper}`}>
          <WPCta
            holder={content}
            selector={`bb-card-cta`}
            pageContext={props.pageContext}
            modals={props.modals}
            translate={false}
            className={`${bulletinBoardCardStyles.cta}`}
          /> 
        </div>
      </div>
    </>
  )
}
